import {Component, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AutoScraperBackendService} from '../auto-scraper-backend.service';
import {Router} from '@angular/router';
import {catchError} from 'rxjs/operators';
import {EMPTY} from 'rxjs';
import {environment} from '../../environments/environment';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    standalone: false
})
export class LoginComponent implements OnInit {
  username = '';
  password = '';
  login_status = '';

  constructor(private http: HttpClient, public data: AutoScraperBackendService, private router: Router) {}

  ngOnInit(): void {
    if (this.data.is_logged_in) {
      this.router.navigate(['/home']);
    }
  }

  /** Authenticates with the given credentials; on success stores the token and navigates to /home. */
  onLogin(): void {
    this.login_status = '';
    this.http.post(environment.apiUrl + '/login', {username: this.username, password: this.password}).pipe(
      catchError(() => {
        this.login_status = 'Could not reach the server. Please try again.';
        return EMPTY;
      })
    ).subscribe(res => {
      if (res === 'Wrong username/password') {
        this.login_status = 'Wrong username or password.';
      } else {
        this.data.setToken(res as string);
        this.router.navigate(['/home']);
      }
    });
  }
}
